import IconButton from "@material-ui/core/IconButton";
import { PauseCircleFilled, PlayCircleFilled } from "@material-ui/icons";
import React from "react";

const iconStyle = { fontSize: 36, color: "#fff" };

const GameClockControls = ({ isRunning, onToggle }) => {
	const handleClick = (e) => {
		e.stopPropagation();
		onToggle();
	};

	return (
		<>
			{isRunning && (
				<IconButton aria-label="pause" onClick={handleClick}>
					<PauseCircleFilled style={iconStyle} />
				</IconButton>
			)}
			{!isRunning && (
				<IconButton aria-label="continue" onClick={handleClick}>
					<PlayCircleFilled style={iconStyle} />
				</IconButton>
			)}
		</>
	);
};

export default GameClockControls;
